exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host .btn {\n  background: #00BBA6;\n  color: #ffffff; }\n  :host .btn:hover:not([disabled]) {\n    background: #00a28f; }\n  :host .btn.default {\n    background: #d4d4d4;\n    color: #505050; }\n    :host .btn.default:hover:not([disabled]) {\n      background: #c7c7c7; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/models/project-parameters/components/parameter-search/parameter-search.component.scss
// module id = ../../../../../src/app/modules/models/project-parameters/components/parameter-search/parameter-search.component.scss
// module chunks = main